import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { listingPropTypes } from '../../utils/commonPropTypes';
import classnames from 'classnames';
import DefaultImage from '../DefaultImage';
import { addResizeParams } from '../../utils/listingHelper';
import './styles.css';
import get from 'lodash/get';
import { prepareImageSrc } from './helpers';

const CarouselItem = (props) => {
  const [mediaError, setMediaError] = useState(false);
  const [mediaLoaded, setMediaLoaded] = useState(false);

  const handleMediaLoaded = () => {
    setMediaLoaded(true);
  };

  const handleMediaError = () => {
    setMediaError(true);
  };

  const handleMediaToDisplay = () => {
    let { media, title, resize } = props;
    let mediaComponent;

    if (get(media, 'mediaType') === 'image') {
      const srcSet = [
        prepareImageSrc(media, 300, 222, 300),
        prepareImageSrc(media, 400, 267, 400),
        prepareImageSrc(media, 700, 466, 700),
        prepareImageSrc(media, 969, 646, 969),
        prepareImageSrc(media, 800, 533, 1200),
        prepareImageSrc(media, 1028, 685, 1600)
      ].join(',');

      const sizes = [
        '(max-width: 300px) 300px',
        '(max-width: 400px) 400px',
        '(max-width: 700px) 700px',
        '(max-width: 969px) 969px',
        '(max-width: 1200px) 1040px',
        '1600px'
      ].join(',');

      const imageParams = {
        srcSet: srcSet,
        sizes: sizes,
        src: addResizeParams(
          media.url,
          resize,
          media.date.modified,
          false,
          'webp'
        ),
        alt: title
      };

      mediaComponent = (
        <>
          <img
            {...imageParams}
            className={classnames('blur image-results', {
              'wide': media.width > 700
            })}
          />
          <img
            {...imageParams}
            className={classnames('centered image-results', {
              'wide': media.width > 700
            })}
            onLoad={handleMediaLoaded}
            onError={handleMediaError}
          />
        </>
      );
    } else if (get(media, 'mediaType') === 'video') {
      const JWPlayer = loadable(() => import('../JWPlayer'));
      mediaComponent = <JWPlayer title={title} media={media} />;
    } else if (get(media, 'mediaType') === '360Image') {
      const Image360 = loadable(() => import('./Image360'));
      Image360.preload();
      const pannellumId = 'item' + Math.floor(Math.random() * 100);
      mediaComponent = <Image360 id={pannellumId} media={media} />;
    } else {
      let videoEmbedUrl = props.current
        ? get(media, 'videoEmbedUrl').replace(/\/v\//i, '/embed/')
        : '';
      mediaComponent = (
        <iframe
          src={videoEmbedUrl}
          style={{ border: 0 }}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={true}
        />
      );
    }
    return mediaComponent;
  };

  let { media, title } = props;
  const mediaElementToDisplay = handleMediaToDisplay();
  return (
    <>
      <div
        className={classnames('item-wrapper', {
          video:
            get(media, 'mediaType') !== 'image' &&
            get(media, 'mediaType') !== '360Image'
        })}
      >
        {media && !mediaError && (props.show || mediaLoaded) ? (
          mediaElementToDisplay
        ) : (
          <DefaultImage title={title} />
        )}
      </div>
    </>
  );
};

CarouselItem.defaultProps = {
  resize: {}
};

CarouselItem.propTypes = {
  /** Defines if the component data is loading */
  isLoading: PropTypes.bool,
  /** The listing of data */
  listing: listingPropTypes,
  /** the item that will be displayed */
  media: PropTypes.object,
  /** The title of the item in the carousel */
  title: PropTypes.string,
  /** size of the object {width: w, heigth: h} */
  resize: PropTypes.object,
  /** show item */
  show: PropTypes.bool,
  /** is it the current shown item */
  current: PropTypes.bool
};
export default memo(CarouselItem);
